import React from 'react';
import Conditional from '../../../common/conditional';
import CustomSectionHeader from '../../custom-section-header';
import { SHELL_ID } from '../../../../utils/ids';

import classNames from './style.module.scss';
import useProjectDetails from '../../../../hooks/useProjectDetails';

interface CustomSectionProps {
	children: React.ReactNode | React.ReactNode[];
	sectionTitle: string;
	sectionSubtitle?: string;
	identifier?: string;
	subidentifier?: string;
	titleStyle?: React.CSSProperties;
	subtitleStyle?: React.CSSProperties;
	showMetadata?: boolean;
	pageBreakClass?: string;
}

const CustomSection: React.FC<CustomSectionProps> = ({
	children,
	sectionSubtitle,
	sectionTitle,
	identifier,
	subidentifier,
	showMetadata = true,
	titleStyle = { backgroundColor: '#ffff0f', color: '#000000' },
	subtitleStyle = { backgroundColor: '#ffff0f', color: '#000000' },
	pageBreakClass = 'pdf-page',
}) => {
	const { projectDetails } = useProjectDetails();

	return (
		<div className={pageBreakClass + ' p-3'} aria-label={sectionTitle} data-id={identifier} data-sub-id={subidentifier}>
			{showMetadata && projectDetails 
				? <CustomSectionHeader 
					organizationLogo={projectDetails.organisation.organisationLogo} 
					organizationName={projectDetails.organisation.organisationName}
					facilityLogo={projectDetails.organisationId === SHELL_ID ? '' : projectDetails.facility.facilityLogo}
					facilityName={projectDetails.facility.facilityName}
				/> 
				: null}

			<div className={classNames.customSection}>
				<div className="container-fluid overflow-hidden p-0">
					<div className={classNames.customSectionHeader} style={titleStyle}>{sectionTitle}</div>
				</div>
				<Conditional isVisible={!!sectionSubtitle}>
					<div className="container-fluid overflow-hidden p-0">
						<div className={classNames.customSectionSubHeader} style={subtitleStyle}>{sectionSubtitle}</div>
					</div>
				</Conditional>

				<div className={classNames.customSectionBody}>{children}</div>
			</div>
		</div>
	);
};

export default CustomSection;
